export const createAnalyticsEvent = (eventAction: string, eventLabel: string): CustomEvent => {
  return new CustomEvent('analytics', { detail: { eventAction, eventLabel }, bubbles: true });
};
